export default __webpack_public_path__ + "static/media/2085.004e0e1a.png";